import { afterNextRender, Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import {
    APP_VERSION,
    APPLICATION_NAME,
    BRAND,
    CUSTOMER_SUPPORT_EMAIL,
    WHATS_APP_CONTACT_SECONDARY_DISPLAY,
    WHATSAPP_MAIN_API_LINK,
} from '../../constants/app.constant';
import { DocumentType } from '../../enum/document.enum';
import { removeWhiteSpace } from '../../helpers/string-utils';
import { MatDialog } from '@angular/material/dialog';
import { DocumentComponent } from '../../../features/document/document.component';
import { FooterService } from './footer-service.component';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit, OnDestroy {
    @ViewChild('footer', { static: true }) footer!: ElementRef;

    protected currentYear = new Date().getFullYear();
    protected whatsAppLinAPILinks: UiWhatsAppLink[] = [];

    protected APPLICATION_NAME = APPLICATION_NAME;
    protected BRAND = BRAND;
    protected WHATS_APP_CONTACT_SECONDARY_DISPLAY = WHATS_APP_CONTACT_SECONDARY_DISPLAY;
    protected APP_VERSION = APP_VERSION;
    protected CUSTOMER_SUPPORT_EMAIL = CUSTOMER_SUPPORT_EMAIL;

    protected DocumentType = DocumentType;

    private observer!: IntersectionObserver;

    constructor(
        private dialog: MatDialog,
        private footerService: FooterService
    ) {
        // This callback does not get called from server-side in SSR.
        afterNextRender(() => {
            this.trackFooterVisibility();
        });
    }

    ngOnInit(): void {
        this.constructWhatsAppAPILink();
    }

    ngOnDestroy(): void {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    protected openDocument(type: string): void {
        this.dialog.open(DocumentComponent, {
            height: '90%',
            autoFocus: false,
            data: {
                type: type,
            },
        });
    }

    private constructWhatsAppAPILink(): void {
        const formalizedWhatsAppNo016 = `6${removeWhiteSpace(WHATS_APP_CONTACT_SECONDARY_DISPLAY).replace('-', '')}`;

        this.whatsAppLinAPILinks = [
            { phoneNo: WHATS_APP_CONTACT_SECONDARY_DISPLAY, link: `${WHATSAPP_MAIN_API_LINK}${formalizedWhatsAppNo016}` },
        ];
    }

    private trackFooterVisibility(): void {
        // IntersectionObserver needs both browser environment and DOM readiness
        this.observer = new IntersectionObserver(
            ([entry]) => {
                this.footerService.setFooterVisibility(entry.isIntersecting);
            },
            { threshold: 0.1 },
        );

        this.observer.observe(this.footer.nativeElement);
    }
}

interface UiWhatsAppLink {
    phoneNo: string;
    link: string;
}
